module.exports = __webpack_public_path__ + "static/media/discordLogo.84848a59.png";